import React from 'react';
import {
    BodyText,
    FlexContainer,
    FlexItem,
    Heading,
    Icon,
    IconColor,
    IconProps,
    Link,
    useTheme,
} from '@placer-ui/components';

type InfoBoxType = 'info' | 'default' | 'error' | 'success';

type InfoBoxProps = {
    testId: string;
    icon?: IconProps['type'];
    title?: string;
    message: string;
    linkText?: string;
    href?: string;
    elevioInlineId?: number;
    type?: InfoBoxType;
};

export const InfoBox = ({
    testId,
    icon,
    message,
    title,
    linkText,
    elevioInlineId,
    type = 'default',
    href,
}: InfoBoxProps) => {
    const { activeTheme, cornerRadius, spacings } = useTheme();

    const backgroundColor = {
        info: activeTheme.theme.background.system,
        default: activeTheme.theme.background.hover,
        error: activeTheme.theme.status.error.background,
        success: activeTheme.theme.status.success.background,
    }[type];

    const iconColorType: Record<InfoBoxType, IconColor> = {
        info: 'brand',
        default: 'gray',
        error: 'error',
        success: 'success',
    };

    return (
        <div
            style={{
                background: backgroundColor,
                borderRadius: cornerRadius.s,
                padding: spacings.s,
            }}
            data-testid={testId}
        >
            <FlexContainer gap={spacings.s}>
                {icon && <Icon testId={`${testId}-icon`} type={icon} color={iconColorType[type]} />}
                <FlexItem>
                    {title && (
                        <Heading testId={`${testId}-title`} variant="h6">
                            {title}
                        </Heading>
                    )}
                    <BodyText testId={`${testId}-message`}>{message}</BodyText>
                    {linkText && (
                        <Link
                            testId={`${testId}-link`}
                            hideUnderline
                            weight="bold"
                            color={type === 'info' ? 'brand' : 'gray'}
                            {...(href ? { href } : {})}
                            {...(elevioInlineId
                                ? {
                                      'data-elevio-inline': elevioInlineId,
                                      'data-elevio-style': 'nothing',
                                  }
                                : {})}
                        >
                            {linkText}
                        </Link>
                    )}
                </FlexItem>
            </FlexContainer>
        </div>
    );
};
